/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_Not_ConfiguredInputs */



/**
* | output |
* | --- |
* | "TWDA submission is not configured on this server" |
*
* @param {Twda_Reason_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_not_configured = /** @type {((inputs?: Twda_Reason_Not_ConfiguredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_Not_ConfiguredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("la soumission au TWDA n'est pas configurée sur ce serveur")
	if (locale === "es") return /** @type {LocalizedString} */ ("el envío al TWDA no está configurado en este servidor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o envio para o TWDA não está configurado neste servidor")
	if (locale === "it") return /** @type {LocalizedString} */ ("l'invio al TWDA non è configurato su questo server")
	return /** @type {LocalizedString} */ ("TWDA submission is not configured on this server")
});